export class DtoUsuarioEdicion {
    Cuadrilla: string = '';
    User: string = '';
    Identificacion: string = '';
}